import { Spinner, Stack, Text } from '@nike/podium';

export default function LoadingButton() {
  return (
    <button type="button" style={{ background: 'none', border: 'none', cursor: 'default', padding: 0 }}>
      <Stack horizontal gap="s" align="center">
        <Spinner size="small" aria-hidden="true" />
        <Text font="body-1" as="span">Retrieving AWS accounts</Text>
      </Stack>
    </button>
  );
}
